import { BillingPlanMetric } from '../metrics/BillingPlanMetric';

export class ConsolidatedMeuConsumption extends BillingPlanMetric {
  constructor(consolidatedMeuConsumption: Partial<ConsolidatedMeuConsumption | null>, billingMetrics: string) {
    super(consolidatedMeuConsumption);
    this.metric.metricId = billingMetrics;
    Object.assign(this, consolidatedMeuConsumption);
  }
}
